import React from 'react';
import ServiceRequestForm from '../components/ServiceRequestForm';

function ServiceRequest() {
  return (
    <>
      <ServiceRequestForm />
    </>
  );
}

export default ServiceRequest;
